/**
 * Resize guard.
 *
 * While the viewport is actively resizing, stamp `is-resizing` on <body> so the
 * stylesheet can suppress transitions/animations (see css/base/resize-guard.css).
 * Without it, crossing a breakpoint mid-drag animates every property whose value
 * differs between the two breakpoints — e.g. the nav sub-menus visibly fade out
 * when the header switches from the mobile drawer to the desktop bar, because
 * their drawer state (opacity 1) transitions to the desktop hidden state.
 */

let brptResizeTimer;

window.addEventListener( 'resize', () => {

	document.body.classList.add( 'is-resizing' );

	clearTimeout( brptResizeTimer );

	brptResizeTimer = setTimeout( () => {
		document.body.classList.remove( 'is-resizing' );
	}, 150 );

}, { passive: true });
